import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { Sun, BatteryCharging, TrendingDown, Clock, Zap, BarChart3 } from 'lucide-react';

export default function SolarStoragePage() {
  return (
    <SolutionPageTemplate
      slug="solar-storage"
      title="Solar + Storage"
      subtitle="Core Solution"
      description="Maximize your solar investment with battery energy storage. Store excess generation during the day and use it during peak hours or after sunset. Combine DG replacement with solar augmentation."
      heroImage="/images/voltide-solar-ev.png"
      path="/solutions/solar-storage"
      sectorLabel="solar"
      useCaseParam="solar_shifting"
      benefits={[
        { icon: Sun, title: 'Solar Time-Shifting', desc: 'Store daytime solar energy and use it in the evening or during peak demand hours.' },
        { icon: TrendingDown, title: 'Peak Shaving', desc: 'Reduce peak demand charges by discharging stored energy during high-tariff periods.' },
        { icon: BatteryCharging, title: 'Grid Independence', desc: 'Reduce dependence on grid power and achieve energy self-sufficiency.' },
        { icon: Clock, title: 'Backup Power', desc: 'Seamless backup during grid outages using stored solar energy.' },
        { icon: Zap, title: 'Zero Export Waste', desc: 'Capture 100% of your solar generation instead of exporting surplus at low rates.' },
        { icon: BarChart3, title: 'Smart Management', desc: 'AI-driven energy management optimizes charge/discharge cycles automatically.' },
      ]}
      howItWorks={[
        { title: 'Solar + Load Analysis', desc: 'We analyze your solar generation profile and consumption pattern to size the optimal storage system.' },
        { title: 'Integrated Deployment', desc: 'BESS is installed alongside your existing or new solar system with seamless integration.' },
        { title: 'Intelligent Operation', desc: 'Smart EMS optimizes when to store, when to discharge, and when to use grid—maximizing your savings.' },
      ]}
      faqs={[
        { q: 'Can I add BESS to my existing solar installation?', a: 'Yes, our systems are designed for retrofit. We integrate with any existing solar inverter setup with minimal modifications.' },
        { q: 'How much additional savings does storage add to solar?', a: 'Typically 15–30% additional savings on top of solar by capturing surplus generation and avoiding peak tariffs.' },
        { q: 'What size battery do I need for my solar system?', a: 'As a rule of thumb, battery capacity (kWh) should be 1.5–2x your solar capacity (kW) for optimal economics. We\'ll calculate the exact ratio for your profile.' },
        { q: 'Does the battery degrade over time?', a: 'Modern lithium-ion batteries retain 80%+ capacity after 10 years of daily cycling. Our warranty covers performance guarantees.' },
        { q: 'Can I go completely off-grid with Solar + Storage?', a: 'For most commercial installations, we recommend a grid-connected setup for optimal economics. However, off-grid configurations are possible for remote sites.' },
      ]}
      productFilter={p => p.battery_kwh >= 400}
    />
  );
}
